import script from "./SubjectFieldAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectFieldAnalytics.vue?vue&type=script&setup=true&lang=js"

export default script